import { render, staticRenderFns } from "./ContactMergeRootView.vue?vue&type=template&id=0bfa9054"
import script from "./ContactMergeRootView.vue?vue&type=script&lang=js"
export * from "./ContactMergeRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports